import { Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppState } from '../../../core';
import { ScoutPointPhotoUploadService } from '../../../core/services';
import { FesBaseComponent } from '../../../shared/components/fes-base.component';

@Component({
  selector: 'app-scout-photos-status-bar',
  templateUrl: './scout-photos-status-bar.component.html',
  styleUrls: ['./scout-photos-status-bar.component.scss']
})
export class ScoutPhotosStatusBarComponent extends FesBaseComponent implements OnInit, OnDestroy {

  static theOne : ScoutPhotosStatusBarComponent

  @Input() set hideOthers( bHideOthers : boolean ) {
    if ( bHideOthers ) {
      ScoutPhotosStatusBarComponent.theOne = this
    }
  }

  errorPhotoCnt = 0
  pendingPhotoCnt = 0
  uploadingPhotoCnt = 0

  constructor(
      public appState : AppState, 
      public scoutPhotoUploadService: ScoutPointPhotoUploadService,
      private modalService: BsModalService) { 
    super(appState)
  }


  ngOnInit(): void {
    this.subscribe(this.scoutPhotoUploadService.uploadNeededCntSubject, cnt => this.pendingPhotoCnt = cnt )
    this.subscribe(this.scoutPhotoUploadService.uploadInProgressCntSubject, cnt => this.uploadingPhotoCnt = cnt )
    this.subscribe(this.scoutPhotoUploadService.uploadFailedCntSubject, cnt => this.errorPhotoCnt = cnt )
  }


  ngOnDestroy() {
    if ( ScoutPhotosStatusBarComponent.theOne == this) {
      ScoutPhotosStatusBarComponent.theOne = null
    }
    this.destroy()
  }


  get inHiding() : boolean {
    return ScoutPhotosStatusBarComponent.theOne != null && ScoutPhotosStatusBarComponent.theOne != this
  }

  
  bRestartingUploader = false
  async restartUploader() {
    this.bRestartingUploader = true
    try {
      this.scoutPhotoUploadService.stop()
      await timer(3*1000).toPromise()
      this.scoutPhotoUploadService.start()
    } catch ( error ) {
      this.appState.publishError(error)
    }
    this.bRestartingUploader = false
  }


  showDetailsPanel = false
  detailModalRef: BsModalRef;
  readonly PhotoUploadsModalId = 4099
  showModal( template: TemplateRef<any> ){
    this.showDetailsPanel = true
    this.detailModalRef = this.modalService.show(template, {
       class: 'modal-lg',
       id: this.PhotoUploadsModalId,
    });
    this.modalService.onHidden.pipe(take(1)).subscribe( (reason:any) => {
      console.log('Photo status modal closing')
      if ( reason.id == this.PhotoUploadsModalId ) {
        this.showDetailsPanel = false
      }
    })
  }
}
